import React from "react";
import EarningsTable from "features/affiliation/Earnings/EarningsTable";
import CardsAndTableLayout from "features/affiliation/common/CardsAndTableLayout";
import EarningsPieChart from "features/affiliation/common/Charts/EarningsPieChart";
import EarningsByMonthBarChart from "features/affiliation/common/Charts/EarningsByMonthBarChart";
import Flex from "common/Boxes/Flex";
import { useEarnings } from "features/affiliation/common/hooks";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation";

import { LanguageNameSpaces } from "@shared/types";

const Earnings = () => {
  const { commissionHistoryQuery } = useEarnings();
  const { t } = useTypedTranslation(LanguageNameSpaces.AFFILIATION);

  const earningsTable = (
    <EarningsTable
      commissions={commissionHistoryQuery.data}
      isLoading={commissionHistoryQuery.isLoading}
    />
  );

  const graph = (
    <Flex
      $flexDirection="column"
      $justifyContent="flex-start"
      style={{ gridGap: 16, height: "100%" }}
    >
      <EarningsPieChart hideTitle={true} />
      <EarningsByMonthBarChart />
    </Flex>
  );

  return (
    <CardsAndTableLayout
      loading={commissionHistoryQuery.isLoading}
      table={earningsTable}
      tableTitle={t("earnings.title")}
      graph={graph}
    />
  );
};

export default Earnings;
